module.exports = __webpack_public_path__ + "img/user.0f6b9e83.jpg";